export default __webpack_public_path__ + "static/media/under-horizontal.e115eb89.svg";